import environment from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/environment.json";

// The standalone auth/app login UI (lazo-x `auth/app`) per environment. The
// deployed environment-{qa,prod}.json files carry an explicit `authAppUrl`;
// the defaults below cover local dev and the checked-in submodule copy of
// environment.json, which the deploy script overwrites and therefore may not
// have the key at compile time — hence the defensive read.
const AUTH_APP_URL_BY_ENV: Record<string, string> = {
  DEV: "https://dev-auth.lazo.one",
  QA: "https://qa-auth.lazo.one",
  PROD: "https://auth.lazo.one",
};

export function authAppUrl(): string {
  const configured = (environment as { authAppUrl?: string }).authAppUrl;
  if (configured) return configured;
  return AUTH_APP_URL_BY_ENV[environment.env] ?? AUTH_APP_URL_BY_ENV.PROD;
}
